import React, { useEffect, useState } from 'react';
import { Navbar } from '../Navbar';
import { Footer } from '../Footer';
import { useTheme } from '../providers/ThemeProvider';
import { TeacherSidebar } from '../TeacherSidebar';
import { MenuIcon, XIcon } from 'lucide-react';
export const CookiePolicyPage = () => {
  const {
    theme
  } = useTheme();
  const isDark = theme === 'dark';
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  // Open sidebar by default on larger screens
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setIsSidebarOpen(true);
      } else {
        setIsSidebarOpen(false);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return <div className={`min-h-screen ${isDark ? 'bg-gradient-to-r from-[#0F1626] via-[#1E3A8A] to-[#2C3E50]' : 'bg-gradient-to-r from-gray-50 to-gray-100'}`} data-id="element-3238">
      <Navbar data-id="element-3239" />

      {/* Mobile sidebar toggle */}
      <button onClick={toggleSidebar} className="lg:hidden fixed bottom-4 right-4 z-30 bg-deep-pink text-white p-3 rounded-full shadow-lg flex items-center justify-center" aria-label={isSidebarOpen ? 'Close menu' : 'Open menu'} style={{
      minWidth: '56px',
      minHeight: '56px'
    }} data-id="element-3240">
        {isSidebarOpen ? <XIcon className="h-6 w-6" data-id="element-3241" /> : <MenuIcon className="h-6 w-6" data-id="element-3242" />}
      </button>

      {/* Left Sidebar */}
      <aside className={`w-64 fixed inset-y-0 pt-20 pb-16 ${isDark ? 'bg-navy-900/90 shadow-lg' : 'bg-white shadow-md'} z-20 transform transition-all duration-300 ease-in-out ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0`} data-id="element-3243">
        <TeacherSidebar darkMode={isDark} closeSidebar={() => setIsSidebarOpen(false)} data-id="element-3244" />
      </aside>

      {/* Main Content */}
      <div className={`pt-20 pb-16 transition-all duration-300 ease-in-out ${isSidebarOpen ? 'lg:ml-64' : 'ml-0 lg:ml-64'}`} data-id="element-3245">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3246">
          <div className={`${isDark ? 'bg-navy-800' : 'bg-white'} rounded-xl shadow-lg p-8 md:p-12`} data-id="element-3247">
            <h1 className={`text-4xl font-bold mb-8 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-3248">
              Cookie Policy
            </h1>

            <div className={`prose prose-lg max-w-none ${isDark ? 'prose-invert' : ''}`} data-id="element-3249">
              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3250">
                <strong data-id="element-3251">Effective Date:</strong> January 15, 2025
              </p>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3252">
                This Cookie Policy explains how MaestroConnect ("we," "us," or
                "our") uses cookies and similar technologies when you access or
                use our platform and services (collectively, the "Services").
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-3253">
                1. What Are Cookies?
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3254">
                Cookies are small text files that are stored on your device
                (computer, tablet, or mobile phone) when you visit a website.
                They help websites remember your preferences, improve your
                experience, and provide essential functionality.
              </p>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3255">
                Cookies can be "session cookies" (which are deleted when you
                close your browser) or "persistent cookies" (which remain on
                your device until they expire or you delete them).
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-3256">
                2. How We Use Cookies
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3257">
                MaestroConnect currently uses cookies only for essential
                purposes required to operate the platform. We do not use cookies
                for advertising, tracking, or selling your data to third
                parties.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-3258">
                3. Types of Cookies We Use
              </h2>

              <h3 className={`text-xl font-semibold mt-6 mb-3 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-3259">
                3.1 Essential Cookies (Strictly Necessary)
              </h3>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-4`} data-id="element-3260">
                These cookies are necessary for the Services to function
                properly and cannot be disabled. They include:
              </p>

              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-3261">
                <li data-id="element-3262">
                  <strong data-id="element-3263">Authentication & Session Management:</strong> Cookies
                  that keep you logged in and maintain your session as you
                  navigate the platform (e.g., Firebase authentication tokens).
                </li>
                <li data-id="element-3264">
                  <strong data-id="element-3265">Security & Fraud Prevention:</strong> Cookies that
                  help protect your account from unauthorized access and detect
                  suspicious activity.
                </li>
                <li data-id="element-3266">
                  <strong data-id="element-3267">Core Platform Functionality:</strong> Cookies that
                  enable essential features such as accessing your dashboard,
                  managing lessons, viewing student progress, and saving
                  settings.
                </li>
                <li data-id="element-3268">
                  <strong data-id="element-3269">Preference Storage:</strong> Cookies that remember
                  your preferences, such as theme mode (dark/light), language
                  settings, and display options.
                </li>
              </ul>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3270">
                These essential cookies do not require your consent under most
                privacy laws because they are necessary to provide the Services
                you have requested.
              </p>

              <h3 className={`text-xl font-semibold mt-6 mb-3 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-3271">
                3.2 Analytics Cookies (Not Currently Used)
              </h3>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3272">
                MaestroConnect does not currently use analytics cookies to track
                your usage or behavior on the platform. If we introduce
                analytics in the future, we will:
              </p>

              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-3273">
                <li data-id="element-3274">Use privacy-first, anonymous analytics tools</li>
                <li data-id="element-3275">Update this Cookie Policy to reflect the change</li>
                <li data-id="element-3276">
                  Implement a cookie consent banner if required by applicable
                  law
                </li>
                <li data-id="element-3277">
                  Provide clear options to opt out of non-essential analytics
                </li>
              </ul>

              <h3 className={`text-xl font-semibold mt-6 mb-3 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-3278">
                3.3 Advertising & Tracking Cookies (Not Used)
              </h3>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3279">
                We do not use advertising cookies, tracking cookies, or
                third-party ad networks. We do not sell, share, or monetize your
                cookie data in any way.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-3280">
                4. Third-Party Cookies
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3281">
                MaestroConnect does not currently allow third-party cookies on
                our platform, except for essential services required to operate
                the platform (such as Firebase for authentication and hosting).
              </p>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3282">
                These third-party services may set their own cookies to provide
                their functionality. We carefully select service providers that
                respect user privacy and comply with data protection
                regulations.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-3283">
                5. Managing Your Cookie Preferences
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-4`} data-id="element-3284">
                You can manage cookies through your browser settings. Most
                browsers allow you to:
              </p>

              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-3285">
                <li data-id="element-3286">View and delete cookies</li>
                <li data-id="element-3287">Block cookies from specific websites</li>
                <li data-id="element-3288">Block all third-party cookies</li>
                <li data-id="element-3289">Clear all cookies when you close your browser</li>
                <li data-id="element-3290">
                  Browse in "incognito" or "private" mode (which deletes cookies
                  when you close the window)
                </li>
              </ul>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3291">
                Please note that if you disable or block essential cookies, you
                may not be able to access certain features of the Services, such
                as logging in, saving preferences, or accessing your dashboard.
              </p>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3292">
                For more information on how to manage cookies in your browser,
                visit:
              </p>

              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-3293">
                <li data-id="element-3294">
                  <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-deep-pink hover:underline" data-id="element-3295">
                    Google Chrome
                  </a>
                </li>
                <li data-id="element-3296">
                  <a href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer" target="_blank" rel="noopener noreferrer" className="text-deep-pink hover:underline" data-id="element-3297">
                    Mozilla Firefox
                  </a>
                </li>
                <li data-id="element-3298">
                  <a href="https://support.apple.com/guide/safari/manage-cookies-sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-deep-pink hover:underline" data-id="element-3299">
                    Safari
                  </a>
                </li>
                <li data-id="element-3300">
                  <a href="https://support.microsoft.com/en-us/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer" className="text-deep-pink hover:underline" data-id="element-3301">
                    Microsoft Edge
                  </a>
                </li>
              </ul>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-3302">
                6. User Consent
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3303">
                Because MaestroConnect currently uses only essential cookies
                required to operate the platform, we do not require your
                explicit consent to use these cookies under most privacy laws
                (including GDPR and CCPA).
              </p>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3304">
                If we introduce non-essential cookies in the future (such as
                analytics or marketing cookies), we will implement a cookie
                consent banner that allows you to accept or decline these
                cookies before they are set.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-3305">
                7. Data Protection & Privacy
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3306">
                The information collected through cookies is subject to our{' '}
                <a href="/privacy-policy" className="text-deep-pink hover:underline" data-id="element-3307">
                  Privacy Policy
                </a>
                . We are committed to protecting your privacy and handling your
                data responsibly.
              </p>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3308">
                We do not sell, rent, or share your cookie data with third
                parties for advertising or marketing purposes. We only use
                cookies to provide and improve the Services.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-3309">
                8. Updates to This Cookie Policy
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3310">
                We may update this Cookie Policy from time to time to reflect
                changes in our practices, technology, or legal requirements. If
                we make material changes, we will notify you by:
              </p>

              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-3311">
                <li data-id="element-3312">Posting a notice on the Services</li>
                <li data-id="element-3313">Sending you an email notification</li>
                <li data-id="element-3314">Updating the "Effective Date" at the top of this policy</li>
              </ul>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3315">
                Your continued use of the Services after the updated Cookie
                Policy takes effect constitutes your acceptance of the changes.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-3316">
                9. Contact Us
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-4`} data-id="element-3317">
                If you have questions or concerns about this Cookie Policy or
                how we use cookies, please contact us:
              </p>

              <div className={`${isDark ? 'bg-navy-700' : 'bg-gray-50'} p-6 rounded-lg mb-6`} data-id="element-3318">
                <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-2`} data-id="element-3319">
                  <strong data-id="element-3320">Email:</strong>{' '}
                  <a href="mailto:support@maestroconnect.com" className="text-deep-pink hover:underline" data-id="element-3321">
                    support@maestroconnect.com
                  </a>
                </p>
                <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-2`} data-id="element-3322">
                  <strong data-id="element-3323">Mail:</strong> MaestroConnect, [Address], [City,
                  State, ZIP]
                </p>
                <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-3324">
                  <strong data-id="element-3325">Phone:</strong> [Phone Number]
                </p>
              </div>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mt-8`} data-id="element-3326">
                Thank you for trusting MaestroConnect. We are committed to
                transparency and protecting your privacy while providing a
                high-quality platform for music education.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Overlay for mobile when sidebar is open */}
      {isSidebarOpen && <div className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-10" onClick={toggleSidebar} aria-hidden="true" data-id="element-3327"></div>}

      <Footer data-id="element-3328" />
    </div>;
};